import React from 'react';
import {Col, Divider, Row} from "antd";
import {CodeTag} from "../Boilerplate/CodeTag";
import AddressLink from "../AddressLink";
import {compose} from "redux";
import {connect} from "react-redux";
import {withLoading, withLoading2, withTransparentLoading} from "../Boilerplate/deferLoaderHoc";
import {getCompanyByShortName, getMyCompany} from "../../actions/companies";
import Spinner from "react-spinkit";
import {createSelector} from "reselect/es"; // fix for Webstorm IDE code analysis
import ComponentNotFound from "../Boilerplate/ComponentNotFound";
import * as R from "ramda";

const _CompanyProfileDisplayFull = props => {
  const { company: { resource: company } = {} } = props;
  if (!company) return <ComponentNotFound resource='company'/>;
  const rowWidth = 24;
  const keyWidth = 11;
  const valWidth = rowWidth-keyWidth;
  return <React.Fragment>
    <Divider><h1>General</h1></Divider>
    <Row className='key-value'>
      <Col span={keyWidth}>Company Name</Col>
      <Col span={valWidth}>{company.companyname}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Company Type</Col>
      <Col span={valWidth}>{company.companytype}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Address</Col>
      <Col span={valWidth}>
        <AddressLink address={{
          street: [company.address, company.address2].join('\n'),
          city: company.city,
          state: company.state,
          zip: company.zip
        }}/>
      </Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Phone</Col>
      <Col span={valWidth}>{company.phone}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Fax</Col>
      <Col span={valWidth}>{company.fax}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Email</Col>
      <Col span={valWidth}><a href={`mailto:${company.email}`}>{company.email}</a></Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Website</Col>
      <Col span={valWidth}><a href={company.website}>{company.website}</a></Col>
    </Row>
    <Divider><h1>Services</h1></Divider>
    <Row className='key-value'>
      <Col span={keyWidth}>Percentage of Work Self-Performed</Col>
      <Col span={valWidth}>{R.path(["Services", "Products and/or Services", "% of Work Self-Performed"], company.pqf)}</Col>
    </Row>
    <Divider>CSI Codes</Divider>
    <Row>
      <Col span={rowWidth}>
        {company.csicodes && company.csicodes.map(code => <CodeTag table='csi' key={code} code={code}/>)}
      </Col>
    </Row>
    <Divider>Industries</Divider>
    <Row>
      <Col span={rowWidth}>
        {company.industries && company.industries.map(code => <CodeTag table='industry' key={code} code={code}/>)}
      </Col>
    </Row>
    <Divider>Sectors</Divider>
    <Row>
      <Col span={rowWidth}>
        {company.sectors && company.sectors.map(code => <CodeTag table='sector' key={code} code={code}/>)}
      </Col>
    </Row>
    <Divider><h1>Work Locations</h1></Divider>
    <Row className='key-value'>
      <Col span={keyWidth}>Areas Worked</Col>
      <Col span={valWidth}>{R.path(["Work Locations", "Geographic Areas", "Areas Worked"], company.pqf)}</Col>
    </Row>
    <Divider><h1>Experience / References</h1></Divider>
    <Divider>Current / Recent Project Reference #1</Divider>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #1 - Project Name</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #1", "Ref #1 - Project Name"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #1 - Owner / End User</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #1", "Ref #1 - Owner/End User"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #1 - General Contractor</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #1", "Ref #1 - General Contractor"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #1 - Reference Contact</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #1", "Ref #1 - Reference Contact (Include Name, Title, Company, Phone, Email)"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #1 - Location</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #1", "Ref #1 - Location (Include City, State, and Country)"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #1 - Contract Value</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #1", "Ref #1 - Contract Value"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #1 - Completion Date</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #1", "Ref #1 - Completion Date (or Estimated Completion Date)"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #1 - Project Description</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #1", "Ref #1 - Project Description"], company.pqf)}</Col>
    </Row>
    <Divider>Current / Recent Project Reference #2</Divider>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #2 - Project Name</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #2", "Ref #2 - Project Name"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #2 - Owner / End User</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #2", "Ref #2 - Owner/End User"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #2 - General Contractor</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #2", "Ref #2 - General Contractor"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #2 - Reference Contact</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #2", "Ref #2 - Reference Contact (Include name, title, company, phone, and email)"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #2 - Location</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #2", "Ref #2 - Location (Include City, State, and Country)"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #2 - Contract Value</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #2", "Ref #2 - Contract Value"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #2 - Completion Date</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #2", "Ref #2 - Completion Date (or Estimated Completion Date)"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #2 - Project Description</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #2", "Ref #2 - Project Description"], company.pqf)}</Col>
    </Row>
    <Divider>Current / Recent Project Reference #3</Divider>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #3 - Project Name</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #3", "Ref #3 - Project Name"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #3 - Owner / End User</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #3", "Ref #3 - Owner/End User"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #3 - General Contractor</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #3", "Ref #3 - General Contractor"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #3 - Reference Contact</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #3", "Ref #3 - Reference Contact (Include name, title, company, phone, and email)"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #3 - Location</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #3", "Ref #3 - Location (Include City, State, and Country)"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #3 - Contract Value</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #3", "Ref #3 - Contract Value"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #3 - Completion Date</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #3", "Ref #3 - Completion Date (or Estimated Completion Date)"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Reference #3 - Project Description</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Current/Recent Project Reference #3", "Ref #3 - Project Description"], company.pqf)}</Col>
    </Row>
    <Divider>Credit / Supplier References</Divider>
    <Row className='key-value'>
      <Col span={keyWidth}>Credit Reference #1</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Credit/Supplier References", "Credit Reference #1 (Include Company Name, Location, Contact Name, Phone, and Email)"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Credit Reference #2</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Credit/Supplier References", "Credit Reference #2 (Include Company Name, Location, Contact Name, Phone, and Email)"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Credit Reference #3</Col>
      <Col span={valWidth}>{R.path(["Experience/References", "Credit/Supplier References", "Credit Reference #3 (Include Company Name, Location, Contact Name, Phone, and Email)"], company.pqf)}</Col>
    </Row>
    <Divider><h1>Company Contacts</h1></Divider>
    <Divider>Primary Contact</Divider>
    <Row className='key-value'>
      <Col span={keyWidth}>First Name</Col>
      <Col span={valWidth}>{R.path(["Company Contact(s)", "Primary Contact", "First Name"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Last Name</Col>
      <Col span={valWidth}>{R.path(["Company Contact(s)", "Primary Contact", "Last Name"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Title</Col>
      <Col span={valWidth}>{R.path(["Company Contact(s)", "Primary Contact", "Title"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Email</Col>
      <Col span={valWidth}>{R.path(["Company Contact(s)", "Primary Contact", "Email"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Phone</Col>
      <Col span={valWidth}>{R.path(["Company Contact(s)", "Primary Contact", "Phone"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Cell</Col>
      <Col span={valWidth}>{R.path(["Company Contact(s)", "Primary Contact", "Cell"], company.pqf)}</Col>
    </Row>
    <Divider>Secondary Contact</Divider>
    <Row className='key-value'>
      <Col span={keyWidth}>First Name</Col>
      <Col span={valWidth}>{R.path(["Company Contact(s)", "Secondary Contact", "2nd: First Name"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Last Name</Col>
      <Col span={valWidth}>{R.path(["Company Contact(s)", "Secondary Contact", "2nd: Last Name"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Title</Col>
      <Col span={valWidth}>{R.path(["Company Contact(s)", "Secondary Contact", "2nd: Title"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Email</Col>
      <Col span={valWidth}>{R.path(["Company Contact(s)", "Secondary Contact", "2nd: Email"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Phone</Col>
      <Col span={valWidth}>{R.path(["Company Contact(s)", "Secondary Contact", "2nd: Phone"], company.pqf)}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Cell</Col>
      <Col span={valWidth}>{R.path(["Company Contact(s)", "Secondary Contact", "2nd: Cell"], company.pqf)}</Col>
    </Row>
  </React.Fragment>;
};

_CompanyProfileDisplayFull.propTypes = {};

const myCompany = createSelector(
  state => state.profile.companyid,
  state => state.companies.data,
  (companyId, companies) => companies[companyId]
);

const companyByUrl = createSelector(
  (_, props) => props.match.params.company,
  state => state.companies.indexes,
  state => state.companies.data,
  (companyName, companyIndexes, companies) => companies[companyIndexes[companyName.toLocaleLowerCase()]]
);

export const PublicCompanyProfileDisplayFull = compose(
  connect(
    (state, props) => {
      let company = companyByUrl(state, props);
      if (!company) return { loading: true };
      return { company };
    },
    (dispatch, props) => ({
      loader: () => dispatch(getCompanyByShortName(props.match.params.company))
    })
  ),
  withLoading
)(_CompanyProfileDisplayFull);

export const CompanyProfileDisplayFull = compose(
  connect(
    (state, props) => {
      let company = myCompany(state, props);
      return {
        company,
      };
    },
  ),
  withLoading2(
    (_, dispatch) => dispatch(getMyCompany()),
    () => <Spinner name='line-scale'/>,
    null,
    ['company']
  )
)(_CompanyProfileDisplayFull);




// WEBPACK FOOTER //
// ./src/components/Settings/CompanyProfileDisplayFull.js